import { 
  BookOutlined,
  PushpinOutlined,
  FileProtectOutlined,
  AuditOutlined,
  QuestionCircleOutlined,
  CustomerServiceOutlined,
  DollarOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

import filesIcono from '../menus/icons/filesIcono.js'

import book from '../menus/icons/book.js'
import encuestasIcono from '../menus/icons/encuestasIcono.js'
import materiaIcono from '../menus/icons/materiaIcono.js'
import reloadIcono from '../menus/icons/reloadIcono.js'
import difusionIcono from './icons/difusionIcono.js'
import tarea from '../menus/icons/tarea.js'




const alumnos = [{
  key: 'Alumnos',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.admin.usuarios.solicitantes',
  icon: BookOutlined,
  breadcrumb: true,
  submenu: [
    {
        key: 'Ayuda',
        path: `${APP_PREFIX_PATH}/pages`,
        title: 'sidenav.ayuda.ayuda',
        icon: QuestionCircleOutlined,
        breadcrumb: true,
        submenu:[{
          key: 'ayuda-preguntas',
          path: `${APP_PREFIX_PATH}/pages/preguntas`,
          title: 'sidenav.ayuda.faq',
          icon: QuestionCircleOutlined,
          breadcrumb: true,
          submenu:[]
        },
        {
          key: 'ayuda-soporte',
          path: `${APP_PREFIX_PATH}/pages/soporte`,
          title: 'sidenav.ayuda.soporte',
          icon: CustomerServiceOutlined,
          breadcrumb: true,
          submenu:[]
        },
        {
            key: 'ayuda-manuales',
            path: `${APP_PREFIX_PATH}/pages/manuales`,
            title: 'sidenav.ayuda.manual',
            icon: book,
            breadcrumb: true,
            submenu:[]
        },
    ]
    }


  ]
}]




   

const Comunicacion = [{
    key: 'comunicacion',
    path: `${APP_PREFIX_PATH}/`,
    title: 'sidenav.comunicacion',
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    submenu:[
    {
      key: 'archivos',
      path: `${APP_PREFIX_PATH}/archivos`,
      title: 'sidenav.archivos',
      icon: filesIcono,
      breadcrumb: true,
      submenu:[]
    },
    {
        key: 'encuestas',
        path: `${APP_PREFIX_PATH}/encuestas`,
        title: 'sidenav.encuestas',
        icon: encuestasIcono,
        breadcrumb: true,
        submenu:[]
    },
    {
        key: 'Examenes',
        path: `${APP_PREFIX_PATH}/examen`,
        title: 'sidenav.examenes',
        icon: tarea, 
        breadcrumb: false,
        submenu: [
        ]
    },
]
}]


const navigationConfig = [...alumnos,...Comunicacion]

export default navigationConfig;
